import { AppState } from '@/store/types';
import { Pages } from '@/types';
import { GetterTree, Module, MutationTree } from 'vuex';

export interface CommonModule extends Module<CommonState, AppState> {
  state: () => CommonState;
  getters: CommonGetters;
  mutations: CommonMutations;
}

export interface CommonState {
  currentPage: Pages | null;
}
export interface CommonGetters extends GetterTree<CommonState, AppState> {
  getCurrentPage: (state: CommonState) => Pages | null;
}

export interface CommonMutations extends MutationTree<CommonState> {
  setCurrentPage: (state: CommonState, currentPage: Pages | null) => void;
}

export const getDefaultState = (): CommonState => ({
  currentPage: null,
});

const state = (): CommonState => getDefaultState();

const getters: CommonGetters = {
  getCurrentPage: (state: CommonState): Pages | null => state.currentPage,
};

const mutations: CommonMutations = {
  setCurrentPage(state: CommonState, currentPage: Pages | null): void {
    state.currentPage = currentPage;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
} as CommonModule;
